import { render, staticRenderFns } from "./WishlistIcon.vue?vue&type=template&id=496b6318&scoped=true&"
import script from "./WishlistIcon.vue?vue&type=script&lang=js&"
export * from "./WishlistIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496b6318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496b6318')) {
      api.createRecord('496b6318', component.options)
    } else {
      api.reload('496b6318', component.options)
    }
    module.hot.accept("./WishlistIcon.vue?vue&type=template&id=496b6318&scoped=true&", function () {
      api.rerender('496b6318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/WishlistIcon.vue"
export default component.exports